import { useAuthContext } from '../../../contexts/AuthContext'
import CreateEnterpriseModal from './components/CreateEnterpriseModal'
import style from './style.module.css'

const SuperUserModals = ({ superModalPath, setSuperModalPath }) => {
  const { isSuperUser } = useAuthContext()

  const handleClose = () => {
    setSuperModalPath('')
  }

  if (isSuperUser && superModalPath) {
    return (
      <div className={style.superUserModals}>
        <div
          className={style.superUserModals_background}
          onClick={handleClose}
        ></div>

        <div className={style.superUserModals_content}>
          {(() => {
            switch (superModalPath) {
              case 'CREATE_ENTERPRISE':
                return <CreateEnterpriseModal handleClose={handleClose} />

              default:
                return
            }
          })()}
        </div>
      </div>
    )
  }
}

export default SuperUserModals
